/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFormBlockCf058Fragment, FormBlockCf058Fragment, FullFormBlockCf058Fragment} from '@amblique/contentful/app/contentful/fragments/form-block-cf058';

/**
 * Get a single FormBlockCf058 by ID (base - scalars only)
 */
export const getBaseFormBlockCf058ById = gql`
  ${BaseFormBlockCf058Fragment}

  query GetBaseFormBlockCf058ById($id: String!, $locale: String!, $preview: Boolean) {
    formBlockCf058(id: $id, locale: $locale, preview: $preview) {
      ...BaseFormBlockCf058Fragment
    }
  }
`;

/**
 * Get a single FormBlockCf058 by ID (standard - 1 level deep)
 */
export const getFormBlockCf058ById = gql`
  ${FormBlockCf058Fragment}

  query GetFormBlockCf058ById($id: String!, $locale: String!, $preview: Boolean) {
    formBlockCf058(id: $id, locale: $locale, preview: $preview) {
      ...FormBlockCf058Fragment
    }
  }
`;

/**
 * Get a single FormBlockCf058 by ID (full - 2 levels deep)
 */
export const getFullFormBlockCf058ById = gql`
  ${FullFormBlockCf058Fragment}

  query GetFullFormBlockCf058ById($id: String!, $locale: String!, $preview: Boolean) {
    formBlockCf058(id: $id, locale: $locale, preview: $preview) {
      ...FullFormBlockCf058Fragment
    }
  }
`;

/**
 * Get all FormBlockCf058 entries with pagination (base - scalars only)
 */
export const getBaseFormBlockCf058s = gql`
  ${BaseFormBlockCf058Fragment}

  query GetBaseFormBlockCf058s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FormBlockCf058Order]
    $where: FormBlockCf058Filter
    $preview: Boolean
  ) {
    formBlockCf058Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseFormBlockCf058Fragment
      }
    }
  }
`;

/**
 * Get all FormBlockCf058 entries with pagination (standard - 1 level deep)
 */
export const getFormBlockCf058s = gql`
  ${FormBlockCf058Fragment}

  query GetFormBlockCf058s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FormBlockCf058Order]
    $where: FormBlockCf058Filter
    $preview: Boolean
  ) {
    formBlockCf058Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FormBlockCf058Fragment
      }
    }
  }
`;

/**
 * Get all FormBlockCf058 entries with pagination (full - 2 levels deep)
 */
export const getFullFormBlockCf058s = gql`
  ${FullFormBlockCf058Fragment}

  query GetFullFormBlockCf058s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FormBlockCf058Order]
    $where: FormBlockCf058Filter
    $preview: Boolean
  ) {
    formBlockCf058Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullFormBlockCf058Fragment
      }
    }
  }
`;
